<template>
  <a :href="orderFormUrl">
    <Card :isPadded="false" hasShadow isRounded>
      <img
        v-if="cardImage"
        :src="cardImage"
        class="w-full h-72 sm:h-60 md:h-48 rounded-t-md"
        :class="{
          'object-cover': orderForm.thumbnail_url,
          'object-contain': !orderForm.thumbnail_url,
        }"
        :alt="orderForm?.title"
      />
      <div
        v-else
        class="flex items-center justify-center w-full h-72 sm:h-60 md:h-48 rounded-t-md bg-gray-500"
      >
        <Icon name="globeAmericas" color="white" size="xxlarge" />
      </div>

      <div class="py-4 text-center">
        <Typography variant="h3">{{ orderForm.title }}</Typography>
      </div>
    </Card>
  </a>
</template>

<script setup>
import { computed } from 'vue'
import { Card, Icon, Typography } from '@aryeo/runway'
import { useAuth } from '@/Hooks/Customer/useAuth'

const { authCustomerUser, authCustomer } = useAuth()

const props = defineProps({
  company: {
    type: Object,
    required: true,
  },
  orderForm: {
    type: Object,
    required: true,
  },
  showingTimePlusBookingIntent: {
    type: Object,
    default: undefined,
  },
})

const cardImage = computed(() => props.orderForm.thumbnail_url || props.company.logo_url)

const orderFormUrl = computed(() => {
  let routeParams = {
    order_form: props.orderForm.id,
    showingtimeplus_booking_intent_id: props.showingTimePlusBookingIntent?.id,
    active_step: props.showingTimePlusBookingIntent ? 1 : null,
  }

  if (authCustomer.value && authCustomerUser.value) {
    routeParams = {
      ...routeParams,
      placing_user_id: authCustomerUser.value.id,
      placing_group_id: authCustomer.value.id,
    }
  }

  return route('web.customer.order-forms.show', routeParams)
})
</script>
